export const UserStatusCssClasses = ["success", "info", ""];
export const UserStatusTitles = ["active", "inactive"];
export const UserConditionCssClasses = ["success", "danger", ""];
export const UserConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "createdAt", order: "desc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    name: "",
    email: "",
    icon: ""
  },
  sortOrder: "desc", // asc||desc
  sortField: "createdAt",
  pageNumber: 1,
  pageSize: 50
};